import { useState, useRef, useEffect } from "react";


const LazyImage = ({ src, alt, className }: { src: string; alt: string; className: string }) => {
  const [isVisible, setIsVisible] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Para não observar mais após carregar
        }
      },
      { threshold: 0.1 }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);
  return (
    <img
      ref={imgRef}
      src={isVisible ? src : ""}
      alt={alt}
      className={className}
      style={{
        transition: "opacity 0.5s ease-in-out",
        opacity: isVisible ? 1 : 0,
      }}  
      loading="lazy"
    />
  );
};

export default LazyImage;